import React, { useState } from 'react'
import AssignedRulesMain from './AssignedRulesMain'
import RulesListMain from './RulesListMain'
export default function mainTabs({ admin }) {
    const [ViewType, setViewType] = useState("assignedRules")

    const ViewTypeHandler = (e) => {
        setViewType(e)
    }

    return (
        <>
            <div className='container-fluid details-new'>

                <div className="btn-group btn-grp-own" role="group" aria-label="onboard-btn" style={{ marginTop: '10px'}}>
                    <button className={`btn btn-outline-primary ${ViewType == "assignedRules" ? "active" : ""}`} style={{ background: '#F1F7FF', color:  '#000' }} onClick={() => ViewTypeHandler('assignedRules')}> Assigned Rules </button>
                    <button className={`btn btn-outline-primary ${ViewType == "rulesList" ? "active" : ""}`} style={{ background: '#F1F7FF', color:  '#000' }} onClick={() => ViewTypeHandler('rulesList')} > Rules List </button>


                </div>

                {/* <div className="row" style={{ marginTop: '10px', padding: '10px' }}>
                    <div className="col-sm-2 col-xs-6">
                        <BasicSelect
                            items={agentsList}
                            SelectedValue={agentType}
                            Changehandler={AgentHandler}
                            label={"Agent Email Id"}
                        />
                    </div>
                    <div className="col-sm-2 col-xs-6">
                        <BasicSelect
                            items={RulesList}
                            SelectedValue={RuleType}
                            Changehandler={RuleHandler}
                            label={"Rule Name"}
                        />
                    </div>
                    <div className="col-sm-2 col-xs-12">
                        <button className="btn" style={{ background: '#2B78FF', width: '100%', background: '#006c67', borderColor: '#006c67', color: '#fff', padding: '12.5px', maxWidth: '90px' }} disabled={agentType === "" || agentType == null || agentType == undefined || RuleType == null || RuleType == undefined || RuleType == "" ? true : false} onClick={() => SaveRule()}>Save</button>
                    </div>
                </div> */}
                {/* <hr /> */}


                {
                    ViewType === 'assignedRules' ?
                        <AssignedRulesMain admin={admin}/>
                        : ''}
                {
                    ViewType === 'rulesList' ?
                        <RulesListMain admin={admin}/>
                        : ''}

            </div>
        </>
    )
}
